import React,{useState,useContext} from "react";
import { Link, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import { BankOwnerContext } from "./BankOwnerContext";
export default function BankOwnerAccount(){
  const {bankOwnerData}=useContext(BankOwnerContext)
      return(
        <div className=" max-w-full min-w-fit">
            <div className=" flex flex-row max-w-full min-w-fit gap-x-4 mb-4 w-40">
            <Link to="change" className=" flex flex-col hover:text-blue-500">
              <FontAwesomeIcon icon={faTachometerAlt} className=" w-12 h-12 hover:text-blue-500"/>account
             </Link>
             <Link to="logout">
               <FontAwesomeIcon icon={faSignOut} className=" w-12 h-12 hover:text-blue-500"/>change
             </Link>            
            </div>
            <div className=" flex flex-col ">
              {bankOwnerData?.profile?<img src={bankOwnerData?.profile} alt={bankOwnerData?.username} className=" h-12 w-12 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>}
               <p>Username :{bankOwnerData?.username}</p>
               <p>Useremail :{bankOwnerData?.email}</p>
               <p>Name :{bankOwnerData?.name}</p>
              </div>
              
             <Outlet/>
        </div>
    )
}